import { setCookie } from "../utils/cookies";
import { $doc } from '../utils/globals';

$doc.on('ready', function() {
    setCookies();
});

function setCookies() {
    let params = new URLSearchParams(window.location.search);
    let utmParams = ['utm_campaign', 'utm_medium', 'utm_term', 'utm_source', 'utm_content'];
    
    utmParams.forEach(function(param) {
        if (params.has(param)) {
            let paramValue = params.get(param);
            setCookie(param, paramValue, 1);
        }
    });
}
